import type { TApiResponse } from '@/types/api-types/TApiResponse'
import ConfigApiUrls from './endpoints'
import BaseApiRequest from '../BaseApiRequest'
import type { IConfigApiRequest, TConfigRequestParams } from '@/types/api-types'

class ConfigApiRequest extends BaseApiRequest implements IConfigApiRequest {
  async addPriceConfig(requestBody: TConfigRequestParams): TApiResponse {
    const url = `${ConfigApiUrls.CONFIG()}`
    return this.post(url, requestBody)
  }
  async getConfigDetails(): TApiResponse {
    const url = `${ConfigApiUrls.CONFIG()}`
    return this.get(url)
  }
}

export default ConfigApiRequest
